// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"185":"swiper-news","452":"swiper-videos","835":"swiper-quotes"}[chunkId] + ".chunk.js";
};